import { Card, Text } from "@components/theming";

export default function QueueStat({
  label,
  value,
}: {
  label?: string;
  value: string;
}) {
  return (
    <Card
      shopsiteClasses="rounded-xl bg-gray-50 px-4 py-3"
      sharedClasses="flex flex-col items-center justify-center"
      variant="classic"
    >
      <Text
        as="p"
        size="5"
        weight="bold"
        shopsiteClasses="text-lg font-black text-black"
      >
        {value}
      </Text>
      {label && (
        <Text
          as="p"
          size="1"
          weight="medium"
          sharedClasses="mt-0.5"
          shopsiteClasses="text-xs leading-relaxed text-gray-500"
          whitelabelClasses="text-[color:var(--gray-11)]"
        >
          {label}
        </Text>
      )}
    </Card>
  );
}
